export default __webpack_public_path__ + "static/media/QR-code-obituary.b124ec6b.svg";